module.exports = __webpack_public_path__ + "img/logo_flight_center_white.9306bc96.svg";